import React, { useEffect, useLayoutEffect, useState } from "react";
import styled from "styled-components";
import root from "react-shadow/styled-components";
import Fuse from "fuse.js";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeExternalLinks from "rehype-external-links";
import {createGlobalStyle} from "styled-components";
import "./chat.css";

const GlobalStyle = createGlobalStyle`
:host {
	all: initial;
	font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu;
	--primary-color: #4F04AF;
	--secondary-color: #F47D28;
	--blue: #1e90ff;
	--white: #ffffff;
}
`;

let continerWidth = 700;

const Container = styled.div`
    :host {
        font-size: initial ;
    }
    margin: 0 auto;
    background: #F5F7F9 url(${process.env.PUBLIC_URL}/bg-pattern.svg);
    min-height: 99vh;
    font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu;
    *{
        box-sizing: border-box;
    }
`;

const ChatHeader = styled.div`
    background-color: var(--primary-color);
    padding: 10px;
    /* border-bottom: 1px solid #ccc; */
    color: #fff;
    height: 50px;
    h1{
        font-size: 20px;
        font-weight: 600;
        line-height: 1px;
    }
   
`;

const ChatBody = styled.div`
    height: calc(100% - 120px);
    overflow-y: auto;
    background-repeat: repeat;
    max-width: ${continerWidth}px;
    margin: 0 auto;
    width: 100%;
    padding-bottom: 80px;
	img[alt="flag"]{
		width: 20px;
		height: 20px;
	}
`;
const AIMessage = styled.div`
        background-color: var(--primary-color);
        color: #fff;
        padding: 12px;
        border-radius: 0 12px 12px 12px;
        
     p{
        margin: 0;
        padding: 0;
        line-height: 1.5;
     }

     a{
        color: #fff !important;
        text-decoration: none;
    }
        `;

const AIChatRow = styled.div`
    padding: 10px;
    display: flex;
    gap: 10px;

    .btn-container.active{
        pointer-events: default;
    }

    .btn-container.inactive{
        pointer-events: none;
        opacity: 0.5;
        cursor: not-allowed;
    }
        
    `;
const HumanChatRow = styled.div`
    padding: 10px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
   
`;

const HumanMessage = styled.div`
    background-color: #E2F0FF;
    padding: 12px;
    border-radius: 12px 0 12px 12px;
    text-align: right;
    p{
        margin: 0;
        padding: 0;
        line-height: 1.5;
     }

`;
const ChatIcon = styled.div`
    height: 35px;
    width: 35px;
    /* background: hsl(50deg 100% 50% / 100%); */
    border-radius: 50%;
    display: flex;
    /* align-content: center; */
    align-items: center;
    justify-content: center;
    color: #393939;
    font-weight: 800;
    flex: 0 0 35px;
    img{
        border-radius: 50%;
        width: 100%;
    }
`;

const ChatName = styled.div`
    padding-bottom: 5px;
    color:#6a6a6a;
    font-size: 12px;
`;

const ChatOption = styled.div`
    background: var(--secondary-color);
    /* border: 1px solid var(--primary-color); */
    display: inline-block;
	color: #fff;
    padding: 1px 20px;
    border-radius: 4px;
    margin: 3px;
    margin-top: 6px;
    font-size: 14px;
    cursor: pointer;
    line-height: 2;
    &:hover{
        background: #ef8438;
    }
    `;
const QuestionButton = styled.div`
    background: #fff;
    border: 1px solid var(--primary-color);
    display: inline-block;
    padding: 1px 20px;
    border-radius: 4px;
    margin: 3px;
    margin-top: 6px;
    font-size: 14px;
    cursor: pointer;
    line-height: 0;
    &:hover{
        background: #D9EFFF;
    }
`;
const ChatFooter = styled.div`
    padding: 10px;
    color: #fff;
    height: 70px;
    position: fixed;
    max-width: ${continerWidth}px;
    background: #fff;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 100%;
    border-radius: 8px 8px 0 0;

    > input {
        width: calc(100% - 60px);
        background: #F3F3F3;
        border: 1px solid #d3d3d3;
        padding: 3px;
        border-radius: 4px 0 0 4px;
        padding-left: 12px;
        outline: none;
        font-size: 16px;
        &:hover, &:focus{
            border: 1px solid var(--primary-color);
            outline: none;
        }
    }
    > button{
        width: 60px;
        background: var(--primary-color);
        border: none;
        color: #fff;
        border-radius: 0 4px 4px 0;
        font-size: 14px;
        cursor: pointer;
    }
`;
const ScrollDiv = styled.div`
    height: 10px;
`;

const AITyping = styled.div`
   height: 33px;
    width: 68px;
    background: var(--primary-color);
    border-radius: 12px;
    padding: 5px;
    margin: 12px 50px;

    span{
        background: #fff;
        height: 10px;
        width: 10px;
        display: inline-block;
        border-radius: 50%;
        margin-left: 5px;
        animation: typing 1s infinite;
        animation-timing-function: cubic-bezier(0.67, 0.02, 0.35, 1.19);
    }
    span:nth-child(2){
        animation-delay: 0.1s;
    }
    span:nth-child(3){
        animation-delay: 0.2s;
    }

    @keyframes typing {
        0%{
            transform: translateY(0);
        }
        50%{
            transform: translateY(5px);

        }
        100%{
            transform: translateY(0);
        }
    }
`;

const InitialLoading = styled.div`
   > div {
    width: 90%;
    height: 100px;
    background: linear-gradient(90deg, #f3f3f3, #e0e0e0, #f3f3f3);
    margin: 10px auto;
    border-radius: 12px;
    animation: move_gradient 2s infinite;
    background-size: 400% 400%;

    @keyframes move_gradient {
        0%{
            background-position: 0% 50%;
        }
        50%{
            background-position: 100% 50%;
        }
        100%{
            background-position: 0% 50%;
        }
    }
}
`;

const RenderSelectWrapper = styled.div`
    max-height: 60%;
	height: 60%;
    max-width: ${continerWidth}px;
    width: 98%;
    background: #fff;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    z-index: 100;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.099);
    border-radius: 12px;
	animation: slideIn 0.5s;
	
    @keyframes slideIn {
        0%{
            transform: translateY(100%) translateX(-50%);
        }
        100%{
            transform: translateY(0) translateX(-50%);
        }
    }
`;

const RenderSelectTitle = styled.div`
    padding: 15px 20px;
    padding-bottom: 10px;
    width: 100%;
    bottom: 0px;
    cursor: text;
    overflow: auto;
    position: sticky;
    top: 0;
    background-color: #F7F7F7;
    z-index: 9999;
    font-weight: 600;
    font-size: 14px;
`;
const SearchContainer = styled.div`
    padding: 10px;
   input[type="search"]{
    display: inline-block;
    border: 1px solid #d9dbdf;
    padding: 10px;
    outline: none;
    font-size: 14px;
    background-color: transparent;
    width: 100%;
    border-radius: 3px;
    &:hover, &:focus{
        border: 1px solid var(--primary-color);
    }
   }
`;
const RenderSelectOption = styled.div<{active:boolean}>`
    padding: 15px 20px;
    cursor: pointer;
    font-size: 14px;
    border-top: 1px solid #d9dbdf;
    background-color: ${props => props.active ? "#c9d5ff" : "#fff"};
    p{
        margin: 0;
        padding: 0;
        line-height: 1.5;
     }
    &:hover{
        background-color: #F7F7F7;
    }
`;
const RenderSelectBox = styled.div`
    overflow-y: auto;
    height: calc(100% - 100px);
    background-color: #fff;
    border-top: 1px solid #d9dbdf;
    border-bottom: 1px solid #d9dbdf;
	display: flex;
    flex-direction: column-reverse;
`;

const generateRandomId = () => {
	return (
		"__BHE__" +
		Math.random().toString(36).substr(2, 9) +
		"__UNI__" +
		Math.random().toString(36).substr(2, 9)
	);
};

const RenderMarkdown = (text:string) => {
	text =  text.replaceAll("<br>", "\n\r");
	return <Markdown	
	rehypePlugins={[rehypeExternalLinks]}
	remarkPlugins={[remarkGfm]} children={text} />
};

const TypeWriter = ({ text, after }: any) => {
	const [currentText, setcurrentText] = useState("");
	const [currentIndex, setcurrentIndex] = useState(0);

	// typing speed 60 wpm if the total words is more than 200, then reduce the increase speed
	let speed = 20;

	
	if (text.length > 100) {
		speed = 1;
	}
	
	useEffect(() => {
		if (currentIndex < text.length) {
			const timer = setTimeout(() => {
				setcurrentText((prev: any) => prev + text[currentIndex]);
				setcurrentIndex((prev: any) => prev + 1);
			}, speed);
			return () => clearTimeout(timer);
		} else {
			setTimeout(() => {
				after();
			}, 300);
		}
	}, [currentIndex, text, after]);
	return <span>{RenderMarkdown(currentText)}</span>;
};

const RenderSelect = ({ data, onSelect, title }: any) => {
	const [displayDatas, setdisplayDatas] = useState(data);
	
	const inputRef = React.useRef<HTMLInputElement>(null);
	const scrollRef = React.useRef<HTMLDivElement>(null);
	const activeRef = React.useRef<HTMLDivElement>(null);
	const [height, setheight] = useState(0);

	const [activeIndex, setactiveIndex] = useState(0);


	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	}, []);


	useEffect(() => {
		let activeHeight = activeRef.current?.offsetHeight || 0;
		setheight((activeHeight * displayDatas.length) + 100);
	}, [displayDatas]);


	return (
		<RenderSelectWrapper style={{ height: height }}>
			<RenderSelectTitle>{title}</RenderSelectTitle>
				<RenderSelectBox ref={scrollRef}>
					{displayDatas.map((option: any, index: any) => (
						<RenderSelectOption 
							ref={activeIndex === index ? activeRef : null}
							active={activeIndex === index}
						key={index} onClick={() => onSelect(option)}>
							{RenderMarkdown(option.text)}
						</RenderSelectOption>
					))}
				</RenderSelectBox>
			<SearchContainer>
				<input
					type="search"
					placeholder="Search"
					ref={inputRef}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							if (displayDatas.length > 0) {
								onSelect(displayDatas[activeIndex]);
							}
						}

						if (e.key === "ArrowDown") {
							if (activeIndex > 0) {
								setactiveIndex(activeIndex - 1);
							}
							
						}

						// up
						if (e.key === "ArrowUp") {
							if (activeIndex < displayDatas.length - 1) {
								setactiveIndex(activeIndex + 1);
							}
						}

						if (scrollRef.current) {
							scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
						}

						// activeRef
						if (activeRef.current) {
							activeRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
						}
						
					}}
					onChange={(e:any) => {
						const fuse = new Fuse(data, {
							keys: ["text"],
							threshold: 0.5,
						});
						if (e.target.value === "") {
							setdisplayDatas(data);
							return;
						}
						const result = fuse.search(e.target.value);
						setdisplayDatas(result.map((r: any) => r.item));

						if (scrollRef.current) {
							scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
						}

						setactiveIndex(0);
						
					}}
				/>
			</SearchContainer>
		</RenderSelectWrapper>
	);
};

const Chat: React.FC = () => {
	const scrollRef = React.useRef<HTMLDivElement>(null);
	const inputRef = React.useRef<HTMLInputElement>(null);
	const chatBodyRef = React.useRef<HTMLDivElement>(null);
	const [currentInput, setcurrentInput] = useState("");
	const [isloading, setisloading] = useState<boolean>(false);
	const [chats, setchats]: [any, any] = useState([]);
	const [session_id, setsession_id] = useState("");
	const [isOpen] = useState(true);
	const [sessiontoken, setsessiontoken] = useState(1);
	const [isInitialLoading, setisInitialLoading] = useState(true);
	const [disableInput, setdisableInput] = useState(false);
	const [isTyping, setisTyping] = useState(false);

	const sentMessage = (message: string, hidden_data: any) => {
		if (message.trim() === "/reset") {
			localStorage.removeItem("session_id");
			window.location.reload();
		}
		const _chats = [...chats, { type: "user", message }];
		setchats(_chats);
		setcurrentInput("");
		setisloading(true);
		scrollIntoView();
		fetch("/api/chat", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				session_id,
				message,
				hidden_data,
			}),
		})
			.then((response) => {
				if (response.ok) {
					setisloading(false);
				}
			})
			.finally(() => {
				setchats([...chats, { type: "user", message }]);
				setcurrentInput("");
				setisloading(false);
				setsessiontoken(sessiontoken + 1);
				scrollIntoView();
			});
	};

	useEffect(() => {
		// check if the session id is already present in the local storage
		const session = localStorage.getItem("session_id");
		try {
			if (session) {
				const { session_id, expiries } = JSON.parse(session);
				const expiriesDate = new Date(expiries);
				const currentDate = new Date();
				if (expiriesDate > currentDate) {
					setsession_id(session_id);
					return;
				}
			}
		} catch (error) { }
		// create a random session id that expires in 1 hour
		const session_id = generateRandomId();
		const expiries = new Date();
		// expiries.setHours(expiries.getHours() + 1);

		// save the session id in the local storage
		localStorage.setItem(
			"session_id",
			JSON.stringify({ session_id, expiries }),
		);
		setsession_id(session_id);
	}, []);

	useLayoutEffect(() => {
		const timer = setTimeout(() => {
			scrollIntoView();
		}, 500);
		return () => clearTimeout(timer);
	}, []);

	const scrollIntoView = () => {
		if (scrollRef.current) {
			scrollRef.current.scrollIntoView({ behavior: "smooth" });
		}
		setTimeout(() => {
			if (chatBodyRef.current) {
				chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
			}
			if (scrollRef.current) {
				scrollRef.current.scrollIntoView({ behavior: "smooth" });
			}
		}, 700);
	};

	useEffect(() => {
		if (!session_id) {
			return;
		}
		if (!isOpen) {
			return;
		}
		setisTyping(true);

		try {
			setisloading(true);
			fetch("/api/chat?session_id=" + session_id)
				.then((response) => response.json())
				.then((data) => {
					setisInitialLoading(false);
					data = data.reverse();
					let _disable_input = false;
					data = data.map((chat: any) => {
						// if buttons is string, try to parse it
						if (typeof chat.buttons === "string") {
							try {
								// if chat.buttons is doesn't have text key, assign the value to text key
								chat.buttons = JSON.parse(chat.buttons);
							} catch (error) {
								chat.buttons = [];
							}
						}
						// if this is last message, and chat contains disabled input, disable the input
						if (chat.disable_input) {
							_disable_input = true;
						}
						return chat;
					});
					setdisableInput(_disable_input);
					data = data.map((chat: any) => {
						if (chat.buttons && chat.buttons.length > 0) {
							chat.buttons = chat.buttons.map((button: any) => {
								if (typeof button === "string") {
									return { text: button };
								}
								return button;
							});
						}
						return chat;
					});
					setchats(data);
				})
				.finally(() => {
					// scroll into view
					if (scrollRef.current) {
						scrollRef.current.scrollIntoView({ behavior: "smooth" });
					}
					//  focus on the input
					if (inputRef.current) {
						inputRef.current.focus();
					}
					setisloading(false);
				});
		} catch (error) { }
	}, [session_id, isOpen, sessiontoken]);

	return (
		<root.div>
			<GlobalStyle />
		

			<Container>
				<ChatHeader>
					<h1>Eligibility Checker</h1>
				</ChatHeader>
				<ChatBody ref={chatBodyRef}>
					{isInitialLoading && (
						<InitialLoading>
							<div className=""></div>
							<div className=""></div>
							<div className=""></div>
						</InitialLoading>
					)}
					{!isInitialLoading &&
						chats.length !== 0 &&
						chats.map((chat: any, index: any) => {
							// if it is last message, and chat contains disabled input, disable the input

							if (chat.type === "system") {
								return (
									<AIChatRow key={index}>
										<ChatIcon>
											<img
												src={process.env.PUBLIC_URL + "/logo.svg"}
												alt="logo"
											/>
										</ChatIcon>
										<div>
											<ChatName>BHEUNi Bot</ChatName>
											<AIMessage>
												{chats.length - 1 === index && (
													<TypeWriter
														text={chat.message}
														after={() => {
															setisTyping(false);
															// scroll into view
															if (scrollRef.current) {
																scrollRef.current.scrollIntoView({
																	behavior: "smooth",
																});
															}
														}}
													/>
												)}
												{chats.length - 1 !== index && RenderMarkdown(chat.message)}
											</AIMessage>
											{!isTyping && chat.buttons && chat.buttons.length > 0 && (
												<div
													className={
														//  active only the last message
														chats.length - 1 === index
															? "active btn-container"
															: "inactive btn-container"
													}
												>
													{chat.buttons.map((option: any, index: any) => (
														<ChatOption
															key={index}
															onClick={() => {
																sentMessage(option.text, {});
															}}
														>
															{option.text}
														</ChatOption>
													))}
												</div>
											)}
											{!isTyping && chats.length - 1 === index &&
												chat.question_type === "buttons" && (
													<>
														{chat.options.map((option: any, index: any) => (
															<QuestionButton
																key={index}
																onClick={() => {
																	sentMessage(option.text, {});
																}}
															>
																<Markdown
																	rehypePlugins={[rehypeExternalLinks]}
																	remarkPlugins={[remarkGfm]}
																>
																	{option.text}
																</Markdown>
																{/* {option.text} */}
															</QuestionButton>
														))}
													</>
												)}
										</div>
										{!isTyping &&  chats.length - 1 === index &&
											chat.question_type === "select" && (
												<RenderSelect
													title={chat.message}
													data={chat.options}
													onSelect={({ value, text }: any) =>
														sentMessage(text, { data: value })
													}
												/>
											)}
				
									</AIChatRow>
								);
							} else {
								return (
									<HumanChatRow key={index}>
										<HumanMessage>
											<Markdown
												rehypePlugins={[rehypeExternalLinks]}
												remarkPlugins={[remarkGfm]}
											>
												{chat.message.replaceAll("<br>", "\n\r")}
											</Markdown>
										</HumanMessage>
									</HumanChatRow>
								);
							}
						})}
					{isloading && (
						<AITyping>
							<span />
							<span />
							<span />
						</AITyping>
					)}
					<ScrollDiv ref={scrollRef}></ScrollDiv>
					
				</ChatBody>
				<ChatFooter style={{ display: disableInput ? "none" : "flex" }}>
					<input
						type="text"
						placeholder="Type your message here"
						ref={inputRef}
						value={currentInput}
						disabled={disableInput || isTyping}
						onChange={(e) => {
							setcurrentInput(e.target.value);
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								sentMessage(currentInput, {});
							}
						}}
					/>
					<button
						onClick={() => {
							sentMessage(currentInput, {});
						}}
					>
						Send
					</button>
				</ChatFooter>
			</Container>
		</root.div>
	);
};

export default Chat;
